import { AboutUsData } from "@modules/about-us/data/mockData";

export interface LeadershipSectionProps {
  data: AboutUsData;
}

export interface TabContentProps {
  data?: AboutUsData;
}

export type TabKey = "boardOfDirectors" | "leadershipWord" | "socialResponsibility" | "subsidiaries";

// Tab configuration for better maintainability
export const TAB_KEYS = {
  BOARD_OF_DIRECTORS: "boardOfDirectors",
  LEADERSHIP_WORD: "leadershipWord", 
  SOCIAL_RESPONSIBILITY: "socialResponsibility",
  SUBSIDIARIES: "subsidiaries",
} as const;

// Type guard to check if a string is a valid TabKey
export function isValidTabKey(value: string): value is TabKey {
  return Object.values(TAB_KEYS).includes(value as TabKey);
}